import { BaseHomeSchema } from './baseHomeSchema'

export abstract class BaseCloseSchema extends BaseHomeSchema {
  constructor() {
    super()
  }

  protected prepare() {
    return {
      ...super.prepare()
    }
  }
}
